module.exports = __webpack_public_path__ + "img/icon-min-zwart.fd4c53e030e36d79bb62802cbaed3fa8.svg";